export default __webpack_public_path__ + "icon-android-507b51fee1f740d76caba4a6e1df311a.svg";